var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "content",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12V10.6667H2V12H0ZM0 9.33333V8H5.33333V9.33333H0ZM0 6.66667V5.33333H12V6.66667H0ZM0 4V2.66667H5.33333V4H0ZM0 1.33333V0H2V1.33333H0ZM3.33333 12V10.6667H5.33333V12H3.33333ZM3.33333 1.33333V0H5.33333V1.33333H3.33333ZM6.66667 12V10.6667H8.66667V12H6.66667ZM6.66667 9.33333V8H12V9.33333H6.66667ZM6.66667 4V2.66667H12V4H6.66667ZM6.66667 1.33333V0H8.66667V1.33333H6.66667ZM10 12V10.6667H12V12H10ZM10 1.33333V0H12V1.33333H10Z",
    fill: "content"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.2a5a0a5213dab3dbe0f83a2ecf8fdbfa.svg";
export { ForwardRef as ReactComponent };